import gql from 'graphql-tag';

export const updateMeterReadingValueMutation = gql(/* GraphQL */ `
  mutation updateMeterReadingValueMutation(
    $updateMeterReadingValue: UpdateMeterReadingValueInput
    $channelId: String!
  ) {
    updateMeterReadingValue(
      meterReadingValue: $updateMeterReadingValue
      channelId: $channelId
    ) {
      id
    }
  }
`);
